export enum FixedLeaveTypeId {
  PAID = '11afbde4-eb56-4438-b613-64a609a6f558', // SnspShift must have 'paid leave' in the DB
  ROSTER = '94dc6bec-1a74-4bec-835f-7151836e7020', // SnspShift must have 'roster day off' in the DB
  UNKNOWN = '__unknown_leave_type__'
}

export const AVAILABLE = 'available';

export const UNKNOWN_LEAVE_TYPE_LABEL = 'unknown'; // This is a UI-only fallback label for deleted historical leave types, so we keep it with the sentinel ID instead of exposing it through the general translation strings.
export const UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR = '#f3f4f6';
export const UNKNOWN_LEAVE_TYPE_SURFACE_COLOR = '#e5e7eb';

export const FIXED_LEAVE_TYPES = [FixedLeaveTypeId.PAID, FixedLeaveTypeId.ROSTER] as string[];
